import { useState } from "react";
import { Card, Carousel, Row, Col } from 'react-bootstrap';
import config from '../../config/config.json';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function WhatWeDo(){
    const [tabSelected, setTabSelected] = useState('services');
    const { t } = useTranslation();
    const navigate = useNavigate();

    const reduceRecipes = (acc, cur, index) => {
        const groupIndex = Math.floor(index / 3);
        if (!acc[groupIndex]) acc[groupIndex] = [];
        acc[groupIndex].push(cur);
        return acc;
    };
    const openWhatWeDo = (e, id) => {
        navigate(`/whatwedo#${id}`);
    }

    return(
        <article>
                <section class="what-we-do">
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <div class="section-title">
                                    <h4>{t('home.whatwedo.title')}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="row"> 
                        <div class="col-12">
                            <button className={`btn btn-whatwedo-tab ${(tabSelected === "services")?'active':''}`} data-tab="services" onClick={()=>setTabSelected("services")}>{t('home.whatwedo.tab_services')}</button>
                            <button className={`btn btn-whatwedo-tab ${(tabSelected === "offerings")?'active':''}`} data-tab="offerings" onClick={()=>setTabSelected("offerings")}>{t('home.whatwedo.tab_offerings')}</button>
                        </div>
                        </div>
                        {tabSelected === "services" && <div class="row tab-services">
                            <div class="col-12">
                                <Carousel interval={2000}>
                                    {config["whatwedo"]["services"].reduce(reduceRecipes, []).map((item, index) => {
                                        return(
                                            <Carousel.Item key={index}>
                                                <Row>
                                                {item.map((item, id)=>{
                                                    return(
                                                        <Col sm={4}>
                                                            {item.id.length > 0 && <div className='card-wrapper'><Card key={id}>
                                                                <Card.Body>
                                                                    <div class={`icon-container ${item.id}`}>
                                                                        <div class="icon"></div>
                                                                    </div>
                                                                    <div class="title">{t(`home.whatwedo.${item.id}`)}</div>
                                                                    <div class="btn-container">
                                                                        <button type="button" class="btn c-button c-gradient" onClick={(e)=>openWhatWeDo(e, item.id)}>{">>"}</button>
                                                                    </div>
                                                                </Card.Body>
                                                            </Card></div>}
                                                        </Col>
                                                    )
                                                })}
                                                </Row>
                                            </Carousel.Item>
                                        )
                                    })}
                                </Carousel>
                            </div>
                        </div>}
                        
                        {tabSelected === "offerings" && <div class="row tab-offerings">
                            <div class="col-12">
                                <Carousel interval={2000}>
                                    {config["whatwedo"]["offerings"].reduce(reduceRecipes, []).map((item, index) => {
                                        return(
                                            <Carousel.Item key={index}>
                                                <Row>
                                                {item.map((item, id)=>{
                                                    return(
                                                        <Col sm={4}>
                                                            {item.id.length > 0 && <div className='card-wrapper'><Card key={id}>
                                                                <Card.Body>
                                                                    <div class={`icon-container ${item.id}`}>
                                                                        <div class="icon"></div>
                                                                    </div>
                                                                    <div class="title">{t(`home.whatwedo.${item.id}`)}</div>
                                                                    <div class="btn-container">
                                                                        <button type="button" class="btn c-button c-gradient" onClick={(e)=>openWhatWeDo(e, item.id)}>{">>"}</button>
                                                                    </div>
                                                                </Card.Body>
                                                            </Card></div>}
                                                        </Col>
                                                    )
                                                })}
                                                </Row>
                                            </Carousel.Item>
                                        )
                                    })}
                                </Carousel>
                            </div>
                        </div>}
                    </div>
                </section>
            </article>
    )
}